import React from "react";
import Slider from "react-slick";
import "./slick.css"

function Carousel(props) {
  return (
    <div className="slider-container">
      <Slider {...props?.settings}>
        {props.children}
      </Slider>
    </div>
  );
}

export default Carousel;
